import { cva, VariantProps } from "cva";
import { PublicationFrequencyType } from "~/types/asgard/Tracker";
import { Body, Icon } from "~/ui-library";
import { ArrowPathIcon } from "~/ui-library/icons";

const iconStyles = cva("fill-transparent stroke-2", {
  variants: {
    publicationFrequency: {
      updates_monthly: "stroke-brand-green-800",
      updates_quarterly: "stroke-brand-green-800",
      updates_weekly: "stroke-brand-green-800",
      this_tracker_is_no_longer_being_updated: "",
      other: "",
    } as Record<PublicationFrequencyType, string>,
  },
});
export type PublicationFrequencyProps = {
  children: React.ReactNode;
  showIcon?: boolean;
} & VariantProps<typeof iconStyles>;

export const PublicationFrequency: React.FC<PublicationFrequencyProps> = ({
  children,
  publicationFrequency,
  showIcon,
}) => (
  <div
    className="flex items-center gap-xxs"
    data-testid="publication-frequency"
  >
    {showIcon ? (
      <Icon
        className={iconStyles({
          publicationFrequency,
        })}
        SvgIcon={ArrowPathIcon}
        size="small"
      />
    ) : null}
    <Body size="small">{children}</Body>
  </div>
);
